/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcOrdersV1BatchOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ORDERS_V1_BATCH_ORDER_STATE_ENTITY_NAME = 'ixc.orders.v1.BatchOrder';
export const ixcOrdersV1BatchOrderStateEntity = new schema.Entity<IxcOrdersV1BatchOrderState>(IXC_ORDERS_V1_BATCH_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'batchOrderId' });

